import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _toConsumableArray from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from '_l/api.request';
import { getLang } from '@/i18n/intl-i18n';
import { USE_MOCK_FALLBACK, getMockCourseRows, getMockNewsRows, getMockCourseGroup, isMockId, OFFICIAL_COURSE_CATEGORY_KEYS, OFFICIAL_NEWS_CATEGORY_KEYS } from "./mock";
function ok(payload) {
  return Promise.resolve({
    data: _objectSpread({
      code: 200,
      msg: 'success'
    }, payload)
  });
}

/**
 * 门户分类列表统一处理:
 * 1. 过滤前端展示中的 Codex 测试分类（不展示管理端测试数据）
 * 2. 过滤没有业务数据的分类, 避免演示时出现空标签
 */
function sanitizeCategories(items) {
  if (!USE_MOCK_FALLBACK) return items || [];
  return (items || []).filter(function (item) {
    var key = item.categoryKey;
    if (!key || String(key).indexOf('codex_') === 0) return false;
    var officialKeys = item.categoryType === 'news' ? OFFICIAL_NEWS_CATEGORY_KEYS : OFFICIAL_COURSE_CATEGORY_KEYS;
    return officialKeys.length ? officialKeys.indexOf(key) >= 0 : true;
  });
}
function formatDate(value) {
  if (!value) return '';
  return String(value).slice(0, 10).replace(/-/g, '.');
}
function courseLanguages(course) {
  if (Array.isArray(course.supportedLanguages)) return course.supportedLanguages.filter(Boolean);
  if (course.supportedLanguages) return course.supportedLanguages.split(',').filter(Boolean);
  if (Array.isArray(course.versions)) return course.versions.map(function (item) {
    return item.language;
  });
  return [course.language || course.defaultLang || 'zh'];
}
function mapCourse(course) {
  if (!course) return null;
  return {
    id: course.id,
    title: course.title,
    desc: course.description,
    courseUrl: course.courseUrl,
    cover: course.coverUrl || course.categoryKey || course.category || 'smart',
    coverUrl: course.coverUrl || '',
    category: course.categoryKey || course.category || 'general',
    categoryLabel: course.categoryName || '',
    hours: course.studyHours || course.hours || 0,
    instructor: course.teacherName || course.teacher || '',
    level: course.level || '',
    type: course.sourceName || '',
    languages: courseLanguages(course),
    defaultLang: course.defaultLang || 'zh',
    selectedLanguage: course.language || course.selectedLanguage || ''
  };
}
function mapNews(item) {
  if (!item) return null;
  return {
    id: item.id,
    date: formatDate(item.publishTime || item.createTime),
    title: item.title || '',
    summary: item.summary || '',
    content: item.content || '',
    source: item.source || '',
    category: item.categoryKey || item.category || 'general_news',
    categoryLabel: item.categoryName || '',
    cover: item.coverUrl
  };
}
function mapCategories(items) {
  return (items || []).map(function (item) {
    return {
      id: item.id,
      key: item.categoryKey,
      translations: (item.translations || []).reduce(function (result, translation) {
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, translation.language, translation.name));
      }, {})
    };
  });
}

// 演示/测试数据过滤 — 隐藏 codex_ 前缀分类下的数据, 避免演示时出现测试内容
function isTestCategory(row) {
  var key = row && (row.category || row.categoryKey);
  return !!key && String(key).indexOf('codex_') === 0;
}

// 明显测试数据过滤 — 标题为纯数字等明显非正式内容, 仅在演示模式下生效
// 例如课程标题 20260924、动态标题 123, 展示效果与错误数据无异
function isObviousTestData(row) {
  if (!USE_MOCK_FALLBACK || !row) return false;
  var title = String(row.title || '').trim();
  return /^\d{2,}$/.test(title);
}

// 关键字过滤 — 接口数据由后端过滤, 演示数据需要本地补一次过滤
function filterByKeyword(rows, keyword) {
  if (!keyword) return rows;
  var text = String(keyword).toLowerCase();
  return rows.filter(function (item) {
    return String(item.title || '').toLowerCase().indexOf(text) >= 0 || String(item.desc || item.summary || '').toLowerCase().indexOf(text) >= 0;
  });
}

// 本地分页 — 演示数据参与分页, 保证 total 与页码一致
function localPage(rows, pageNum, pageSize) {
  var page = Number(pageNum) || 1;
  var size = Number(pageSize) || 10;
  return {
    total: rows.length,
    rows: rows.slice((page - 1) * size, page * size)
  };
}

// 兜底收集分类 key — 分类接口不可用时, 依据现有数据推断
function collectCategoryKeys(realRows, mockRows) {
  var keys = [];
  (realRows || []).concat(mockRows || []).forEach(function (item) {
    var key = item && item.category;
    if (key && key !== 'all' && keys.indexOf(key) < 0) keys.push(key);
  });
  return keys;
}

// 每个类别最少展示条数 — 接口数据不足时用演示数据补齐
var MIN_PER_CATEGORY = 2;

/**
 * 单类别取值: 接口数据优先;
 * 接口条数达到 MIN_PER_CATEGORY 时只用接口数据, 不足时用演示数据补到 maxCount 条
 */
function fillCategory(realRows, mockRows, key, maxCount) {
  var max = maxCount || 3;
  var real = (realRows || []).filter(function (item) {
    return String(item.category) === String(key);
  });
  if (real.length >= MIN_PER_CATEGORY) return real;
  var mock = (mockRows || []).filter(function (item) {
    return String(item.category) === String(key);
  });
  var seen = {};
  var merged = [];
  real.concat(mock).forEach(function (item) {
    if (merged.length >= max) return;
    if (seen[item.id]) return;
    seen[item.id] = true;
    merged.push(item);
  });
  return merged;
}

/**
 * 按类别补齐演示数据, 并按类别交错合并:
 * - 接口数据达标的类别: 只用接口数据
 * - 接口数据不足的类别: 用演示数据补齐
 * 说明: 分类顺序沿用后端分类顺序, 保证前端展示稳定
 */
function mergeByCategory(realRows, mockRows, categoryKeys, maxPerCategory) {
  var keys = categoryKeys && categoryKeys.length ? categoryKeys : collectCategoryKeys(realRows, mockRows);
  var buckets = keys.map(function (key) {
    return fillCategory(realRows, mockRows, key, maxPerCategory);
  });
  var merged = [];
  var depth = buckets.reduce(function (max, bucket) {
    return Math.max(max, bucket.length);
  }, 0);
  var _loop = function _loop(i) {
    buckets.forEach(function (bucket) {
      if (bucket[i]) merged.push(bucket[i]);
    });
  };
  for (var i = 0; i < depth; i++) {
    _loop(i);
  }
  var rest = (realRows || []).filter(function (item) {
    return merged.indexOf(item) < 0;
  });
  return merged.concat(rest);
}
function languageParam() {
  return {
    language: getLang()
  };
}
export function getFeatureNews() {
  return axios.request({
    url: '/system/intl/portal/news/feature',
    method: 'get',
    params: languageParam()
  }).then(function (res) {
    if (res.code !== 200) return res;
    var feature = res.data && !isTestCategory(res.data) ? mapNews(res.data) : null;
    if (feature) return ok({
      data: feature
    });
    if (!USE_MOCK_FALLBACK) return ok({
      data: null
    });
    var fallback = getMockNewsRows(OFFICIAL_NEWS_CATEGORY_KEYS[0], getLang())[0];
    return ok({
      data: fallback ? mapNews(fallback) : null
    });
  });
}
export function getNewsTopList(params) {
  return getNewsList(params);
}
export function getNewsList(params) {
  var pageNum = Number(params && params.pageNum) || 1;
  var pageSize = Number(params && params.pageSize) || 10;
  var keyword = params && params.keyword || '';
  var query = _objectSpread(_objectSpread({}, params), languageParam());
  if (query.category && query.category !== 'all') {
    query.categoryKey = query.category;
  }
  delete query.category;
  var category = params && params.category || 'all';

  // 关闭兜底时保持原有接口分页行为
  if (!USE_MOCK_FALLBACK) {
    return axios.request({
      url: '/system/intl/portal/news/list',
      method: 'get',
      params: query
    }).then(function (res) {
      if (res.code !== 200) return res;
      return ok({
        rows: (res.rows || []).map(mapNews).filter(function (item) {
          return !isTestCategory(item) && !isObviousTestData(item);
        }),
        total: res.total || 0
      });
    });
  }
  return axios.request({
    url: '/system/intl/portal/news/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, query), {}, {
      pageNum: 1,
      pageSize: 200
    })
  }).catch(function () {
    return {
      code: 200,
      rows: []
    };
  }).then(function (res) {
    var realRows = res.code === 200 ? filterByKeyword((res.rows || []).map(mapNews).filter(function (item) {
      return !isTestCategory(item) && !isObviousTestData(item);
    }), keyword) : [];
    var mockRows = filterByKeyword(getMockNewsRows(category !== 'all' ? category : '', getLang()).map(mapNews), keyword);
    var merged = category !== 'all' ? fillCategory(realRows, mockRows, category, 3) : mergeByCategory(realRows, mockRows, OFFICIAL_NEWS_CATEGORY_KEYS, 2);
    var page = localPage(merged, pageNum, pageSize);
    return ok({
      rows: page.rows,
      total: page.total
    });
  });
}
export function getNewsDetail(id) {
  if (USE_MOCK_FALLBACK && isMockId(id)) {
    var mock = getMockNewsRows('', getLang()).find(function (item) {
      return String(item.id) === String(id);
    });
    return Promise.resolve(ok({
      data: mock ? mapNews(mock) : null
    }));
  }
  return axios.request({
    url: "/system/intl/portal/news/".concat(id),
    method: 'get',
    params: languageParam()
  }).then(function (res) {
    if (res.code !== 200) return res;
    return ok({
      data: mapNews(res.data)
    });
  });
}
export function getCourseTopList(params) {
  return getCourseList(params);
}
export function getCourseList(params) {
  var pageNum = Number(params && params.pageNum) || 1;
  var pageSize = Number(params && params.pageSize) || 10;
  var keyword = params && params.keyword || '';
  var query = _objectSpread(_objectSpread({}, params), languageParam());
  if (query.category === 'all') {
    delete query.category;
  } else if (query.category) {
    query.categoryKey = query.category;
    delete query.category;
  }
  var category = params && params.category || 'all';

  // 关闭兜底时保持原有接口分页行为
  if (!USE_MOCK_FALLBACK) {
    return axios.request({
      url: '/system/intl/portal/course/list',
      method: 'get',
      params: query
    }).then(function (res) {
      if (res.code !== 200) return res;
      return ok({
        rows: (res.rows || []).map(mapCourse).filter(function (item) {
          return !isTestCategory(item) && !isObviousTestData(item);
        }),
        total: res.total || 0
      });
    });
  }
  return axios.request({
    url: '/system/intl/portal/course/list',
    method: 'get',
    params: _objectSpread(_objectSpread({}, query), {}, {
      pageNum: 1,
      pageSize: 200
    })
  }).catch(function () {
    return {
      code: 200,
      rows: []
    };
  }).then(function (res) {
    var realRows = res.code === 200 ? filterByKeyword((res.rows || []).map(mapCourse).filter(function (item) {
      return !isTestCategory(item) && !isObviousTestData(item);
    }), keyword) : [];
    var mockRows = filterByKeyword(getMockCourseRows(category !== 'all' ? category : '', getLang()).map(mapCourse), keyword);
    var merged = category !== 'all' ? fillCategory(realRows, mockRows, category, 3) : mergeByCategory(realRows, mockRows, OFFICIAL_COURSE_CATEGORY_KEYS, 3);
    var page = localPage(merged, pageNum, pageSize);
    return ok({
      rows: page.rows,
      total: page.total
    });
  });
}
function requestCourseGroup(id, lang) {
  // 演示课程直接由本地数据构造课程组结构
  if (USE_MOCK_FALLBACK && isMockId(id)) {
    return Promise.resolve({
      code: 200,
      data: getMockCourseGroup(id, lang || getLang())
    }).then(function (result) {
      if (!result.data) return {
        code: 404,
        msg: 'course not found'
      };
      return result;
    });
  }
  return axios.request({
    url: "/system/intl/portal/course/group/".concat(id),
    method: 'get',
    params: {
      lang: lang || getLang()
    }
  });
}

// 课程组返回结构 -> 课程卡片/详情数据结构
function buildCourseFromGroup(payload) {
  var selected = payload.selectedVersion || {};
  return _objectSpread(_objectSpread(_objectSpread({}, payload.course), selected), {}, {
    id: payload.course ? payload.course.id : undefined,
    coverUrl: payload.course && payload.course.coverUrl || selected.coverUrl || '',
    supportedLanguages: payload.supportedLanguages,
    category: payload.category,
    categoryKey: payload.category,
    categoryName: payload.categoryName
  });
}
export function getCourseDetail(id) {
  return requestCourseGroup(id).then(function (res) {
    if (res.code !== 200) return res;
    return ok({
      data: mapCourse(buildCourseFromGroup(res.data || {}))
    });
  });
}
export function getCourseLearning(id) {
  return requestCourseGroup(id).then(function (res) {
    if (res.code !== 200) return res;
    var payload = res.data || {};
    var selected = payload.selectedVersion || {};
    return ok({
      data: {
        course: mapCourse(buildCourseFromGroup(payload)),
        selectedLanguage: payload.selectedLanguage || selected.language || getLang(),
        chapters: selected.chapters || []
      }
    });
  });
}
export function getCourseOutline(id) {
  return requestCourseGroup(id).then(function (res) {
    if (res.code !== 200) return res;
    var selected = (res.data || {}).selectedVersion || {};
    return ok({
      data: selected.chapters || []
    });
  });
}
export function getRelatedCourses(_x) {
  return _getRelatedCourses.apply(this, arguments);
}
function _getRelatedCourses() {
  _getRelatedCourses = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
    var detailRes, payload, category, _rows, query, res, realRows, rows, mockRows;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return requestCourseGroup(id);
        case 1:
          detailRes = _context.sent;
          if (!(detailRes.code !== 200)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", detailRes);
        case 2:
          payload = detailRes.data || {};
          category = payload.category;
          if (!(USE_MOCK_FALLBACK && isMockId(id))) {
            _context.next = 3;
            break;
          }
          _rows = getMockCourseRows(category, getLang()).filter(function (item) {
            return String(item.id) !== String(id);
          }).slice(0, 4).map(mapCourse);
          return _context.abrupt("return", ok({
            data: _rows
          }));
        case 3:
          query = _objectSpread({
            pageNum: 1,
            pageSize: 5,
            category: category
          }, languageParam());
          if (!query.category) delete query.category;
          _context.next = 4;
          return axios.request({
            url: '/system/intl/portal/course/list',
            method: 'get',
            params: query
          });
        case 4:
          res = _context.sent;
          if (!(res.code !== 200)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", res);
        case 5:
          realRows = (res.rows || []).filter(function (item) {
            return String(item.id) !== String(id);
          });
          rows = realRows;
          if (rows.length < 4) {
            mockRows = getMockCourseRows(category, getLang()).filter(function (item) {
              return String(item.id) !== String(id) && !realRows.some(function (real) {
                return String(real.id) === String(item.id);
              });
            });
            rows = realRows.concat(mockRows);
          }
          rows = rows.slice(0, 4).map(mapCourse);
          return _context.abrupt("return", ok({
            data: rows
          }));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getRelatedCourses.apply(this, arguments);
}
export function getCourseCategories() {
  return axios.request({
    url: '/system/intl/portal/course/categories',
    method: 'get'
  }).then(function (res) {
    if (res.code !== 200) return res;
    var rows = [{
      id: 'all',
      key: 'all',
      translations: {}
    }].concat(_toConsumableArray(mapCategories(sanitizeCategories(res.data))));
    return ok({
      data: rows
    });
  });
}
export function getSupportedLanguages() {
  return axios.request({
    url: '/system/intl/portal/languages',
    method: 'get'
  }).then(function (res) {
    if (res.code !== 200) return res;
    return ok({
      data: res.data || []
    });
  });
}
export function getNewsCategories() {
  return axios.request({
    url: '/system/intl/portal/news/categories',
    method: 'get'
  }).then(function (res) {
    if (res.code !== 200) return res;
    var rows = [{
      id: 'all',
      key: 'all',
      translations: {}
    }].concat(_toConsumableArray(mapCategories(sanitizeCategories(res.data))));
    return ok({
      data: rows
    });
  });
}